export function fixCardVisualizationContrast() 
{
  // Only run on cart page
  if (!window.location.pathname.includes('/cart')) 
{
    return;
  }

  const observer = new MutationObserver(() => 
{
    document.querySelectorAll('egov-card-visualization .placeholder').forEach((el) => 
{
      const htmlEl = el as HTMLElement;
      const computedStyle = window.getComputedStyle(htmlEl);
      if (computedStyle.backgroundColor === 'rgb(255, 255, 255)' || computedStyle.backgroundColor === 'white') 
{
        htmlEl.style.setProperty('color', 'rgb(255 255 255)', 'important');
        htmlEl.style.setProperty('background-color', 'rgb(68, 68, 68)', 'important');
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true, attributes: true });
  
  // Fix existing elements
  document.querySelectorAll('egov-card-visualization .placeholder').forEach((el) => 
{
    const htmlEl = el as HTMLElement;
    const computedStyle = window.getComputedStyle(htmlEl);
    if (computedStyle.backgroundColor === 'rgb(255, 255, 255)' || computedStyle.backgroundColor === 'white') 
{
      htmlEl.style.setProperty('color', 'rgb(255 255 255)', 'important');
      htmlEl.style.setProperty('background-color', 'rgb(68, 68, 68)', 'important');
    }
  });
}

if (document.readyState === 'loading') 
{
  document.addEventListener('DOMContentLoaded', fixCardVisualizationContrast);
}
 else 
{
  fixCardVisualizationContrast();
}